// Pixel do ChatGPT Ads (OpenAI). O SDK guarda o `oppref` do anúncio no cookie
// __oppref, que o servidor reaproveita na Conversions API.
const SDK_URL = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';

export const loadOpenaiPixel = pixelId => {
  if (!window.oaiq) {
    const queue = (...args) => {
      queue.q.push(args);
    };
    queue.q = [];
    window.oaiq = queue;
    const script = document.createElement('script');
    script.async = true;
    script.src = SDK_URL;
    document.head.appendChild(script);
  }
  window.oaiq('init', { pixelId });
};

export const trackOpenaiPageView = (id, name) => {
  window.oaiq('measure', 'page_viewed', {
    type: 'contents',
    contents: [{ id, name, content_type: 'page' }],
  });
};

export const trackOpenaiLead = eventId => {
  window.oaiq(
    'measure',
    'lead_created',
    { type: 'customer_action' },
    eventId ? { event_id: eventId } : {}
  );
};
